import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import { roundedTextFieldStyles } from "./roundedTextFieldStyles";

const RoundedProfileTextField = styled(TextField)({
  ...roundedTextFieldStyles,
  textTransform: "capitalize",
  "& .MuiInputBase-input": {
    ...roundedTextFieldStyles["& .MuiInputBase-input"],
    padding: "15px",
  },
});

export default RoundedProfileTextField;
